import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import momentJalaali from 'moment-jalaali';
import { Calendar } from 'react-datepicker2';
import Button from '@material-ui/core/Button';

const DatePicker = ({ onClose, data }) => {
  const { open, fieldName } = data;
  const [date, setDate] = useState(momentJalaali());
  const handleChange = (date) => {
    setDate(date);
  };
  const handleOnClose = () => {
    onClose({ date, fieldName });
  };
  return (
    <Dialog open={open}>
      <MuiDialogContent>
        <Calendar value={date} isGregorian={false} onChange={handleChange} />
      </MuiDialogContent>
      <MuiDialogActions>
        <Button variant="contained" color="primary" onClick={handleOnClose}>
          انتخاب
        </Button>
      </MuiDialogActions>
    </Dialog>
  );
};

export default DatePicker;
